
(function(){
  function init(root){
    if(!root || root.dataset.mcpInit === 'true') return;
    root.dataset.mcpInit = 'true';

    root.querySelectorAll('[data-mcp-faq-toggle]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const item = btn.closest('.mcp-faq-item');
        const isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('.mialica-contact').forEach(init));
  document.addEventListener('shopify:section:load',e=>{
    const root = e.target.querySelector('.mialica-contact') || (e.target.matches?.('.mialica-contact') ? e.target : null);
    if(root) init(root);
  });
})();
